import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=266938f0&scoped=true&"
import script from "./Addresses.vue?vue&type=script&lang=js&"
export * from "./Addresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266938f0",
  null
  
)

export default component.exports